import { Button, Code, Space, Table } from '@mantine/core';
import { IconPencilPlus } from '@tabler/icons-react';
import { PageHeader } from '../../../components/PageHeader';
import { Paper } from '../../../components/Paper';
import { Title } from '../../../components/Title';
import { useModal } from '../../../hooks/useModal';
import { whiteIconButtonStyle } from '../../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { query } from '../../../util/api/query';
import type { OrganisationDto } from '../../../util/types/OrganisationDto';
import { NewOrganisationModal } from './NewOrganisationModal';
import { OrganisationTableRow } from './OrganisationTableRow';
import { KeyedRow } from '../../../components/KeyedRow';

export function OrganisationsView() {
	const newModal = useModal();

	const orgQuery = query<OrganisationDto[]>('organisation/all');

	const triggerListUpdate = () => {
		orgQuery.remove();
		orgQuery.refetch();
	};

	return (
		<>
			<NewOrganisationModal
				opened={newModal.isOpen}
				close={newModal.close}
				triggerListUpdate={triggerListUpdate}
			/>
			<PageHeader title={'Organisations'} hideFiltering>
				<Button
					{...whiteIconButtonStyle}
					onClick={() => newModal.open()}
					data-cy={'create-iconButton'}
				>
					<IconPencilPlus {...defaultIconStyle} />
				</Button>
			</PageHeader>
			<Code>
				Editing an organisation name that is being actively used will lead to
				errors.
			</Code>
			<Space h={20} />
			<Paper>
				<Table striped>
					<Table.Thead>
						<KeyedRow>
							<Table.Th w={'10vw'}>
								<Title label={'Organisation Name'} />
							</Table.Th>
							<Table.Th w={'20vw'}>
								<Title label={'Formatted For Url'} />
							</Table.Th>
							<Table.Th w={'20vw'}>
								<Title label={'Phone Number'} />
							</Table.Th>
							<Table.Th>
								<Title label={'Email'} />
							</Table.Th>
							<Table.Th w={'20vw'}>
								<Title label={'Connection String'} />
							</Table.Th>
							<Table.Th w={'2vw'}>
								<Title label={'Edit'} />
							</Table.Th>
							<Table.Th w={'2vw'}>
								<Title label={'Delete'} />
							</Table.Th>
						</KeyedRow>
					</Table.Thead>
					<Table.Tbody>
						{orgQuery.data?.value.map((o) => (
							<OrganisationTableRow
								key={o.id}
								org={o}
								triggerListUpdate={triggerListUpdate}
							/>
						))}
					</Table.Tbody>
				</Table>
			</Paper>
		</>
	);
}
